import React, { useState, useEffect, useRef } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { sendAuthenticatedAsyncRequest } from 'services/AsyncRequestService';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DismissableModal from 'components/DismissableModal';
import { FormGroup } from 'react-bootstrap';
import { showNotification } from 'services/NotificationService';
import Select from "react-select";
import { getErrorMessage } from "services/UtilityService";
import Spinner from './Spinner';
import { customMultiSelectStyles } from 'commons/styles/CustomStyles';


const AutoAcceptEnablement = () => {

    const modalRef = useRef("autoAcceptEnablement");
    const [customersList, setCustomersList] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCustomers = () => {
        sendAuthenticatedAsyncRequest(
            `/customers/list`,
            "GET",
            null,
            (r) => {
                const allCustomers = r.data.map((c) => ({
                    label: c.name,
                    value: c.id,
                    flag: c.isAutoAcceptEnabled
                }));
                setCustomersList(allCustomers);
                setSelectedCustomers(allCustomers.filter(c => c.flag));
                setLoading(false);
            },
            (r) => {
                setCustomersList([]);
                setSelectedCustomers([]);
                setLoading(false);
            }
        );
    }

    const submitForm = (originalValues, setSubmitting, closeModal) => {
        const dto = {
            customerIds: originalValues.customers
        }
        sendAuthenticatedAsyncRequest(
            `/customers/auto-accept-enablement/update`,
            "PUT",
            dto,
            (r) => {
                setSubmitting(false);
                showNotification({
                    title: 'Action successful!',
                    message: 'Customer Auto Accept settings updated successfully.',
                    position: 'tr',
                    type: "success"
                });
                closeModal();
            },
            (r) => {
                setSubmitting(false);
                showNotification({
                    title: 'Error!',
                    message: getErrorMessage(r.data) || getErrorMessage('SAVE_CUSTOMER_AUTO_ACCEPT_SETTING_FAILED'),
                    position: 'tr',
                    type: "error"
                });
            }
        );
    }

    const onMultiSelectChange = (selectedOptions, setFieldValue) => {
        const tempList = (selectedOptions || []).map((x) => x.value);
        setFieldValue('customers', tempList);
    }

    useEffect(() => {
        fetchCustomers();
    }, []);

    return (<>
        <Card style={{ textAlign: 'center' }}>
            <Card.Body>
                <Card.Text>
                    Enable/Disable Customer Auto Accept.
                </Card.Text>
                <DismissableModal
                    ref={modalRef}
                    openModalButtonText="Auto accept"
                    openModalButtonStyle="info"
                    openModalButtonBlock={true}
                    openModalButtonDisabled={false}
                    openModalButtonId='customer-auto-accept-btn-popup'
                    preventCloseWhenClickedOutsideModal={true}
                    onClose={() => fetchCustomers()}
                    hideFooter={true}
                    title="Customer Auto Accept Enablement" >
                    {loading ? <Spinner /> : (<Formik
                        initialValues={{
                            customers: selectedCustomers.map((customer) => customer.value)
                        }}
                        onSubmit={(values, { setSubmitting, setValues }) => {
                            submitForm(values, setSubmitting, modalRef.current.handleClose);
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            dirty,
                            isValid
                        }) => (
                            <>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Form.Label>Auto Accept enabled for customers:</Form.Label>
                                                <Select
                                                    isMulti
                                                    placeholder="Select Customer"
                                                    options={customersList}
                                                    isClearable={false}
                                                    name="customers"
                                                    value={customersList.filter((opt) =>
                                                        values.customers.includes(opt.value)
                                                    )}
                                                    onChange={(selected) =>
                                                        onMultiSelectChange(selected, setFieldValue)
                                                    }
                                                    styles={{...customMultiSelectStyles}}
                                                />
                                                <Form.Text className="text-small text-danger">
                                                    {errors.switchList}
                                                </Form.Text>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="top-spacer">
                                        <Col md={4} className="bottom-spacer">
                                            <Button
                                                type="submit"
                                                variant="success"
                                                className="btn-block btn-text-white"
                                                block
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? "Saving ... " : "Save"}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </>
                        )}
                    </Formik>)}
                </DismissableModal>
            </Card.Body>
        </Card>
    </>)
}

export default AutoAcceptEnablement;